var render = function render(){var _vm=this,_c=_vm._self._c;return _c('edit-view-base',{attrs:{"filter":_vm.filter,"has-card-view":false,"cards":_vm.cards,"tabs":_vm.tabs,"main-form":_vm.mainForm,"claim-name":_vm.claimName,"api-method":_vm.apiMethod,"item-id":_vm.itemId,"refresh-key":_vm.refreshKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }